import { memo, ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

export interface InputPanelContainerV1Properties {
  children: ReactNode;
  className?: string;
}

const InputPanelContainerV1 = memo(({ children, className }: InputPanelContainerV1Properties) => (
  <Box
    className={className}
    display='flex'
    flexDirection='column'
    gap={BUILDER_MODE_V1_LAYOUT.inputPanelGap}
    w='100%'
    h='100%'
    p={BUILDER_MODE_V1_LAYOUT.inputPanelPadding}
    borderRadius={BUILDER_MODE_V1_LAYOUT.inputPanelRadius}
    border='1px solid'
    borderColor={BUILDER_MODE_V1_TOKENS.border}
    bgGradient={`linear(to-b, ${BUILDER_MODE_V1_TOKENS.activeBg}, ${BUILDER_MODE_V1_TOKENS.white})`}
    boxShadow={BUILDER_MODE_V1_LAYOUT.inputPanelShadow}
    overflow='hidden'
  >
    {children}
  </Box>
));

InputPanelContainerV1.displayName = 'InputPanelContainerV1';

export default InputPanelContainerV1;
